// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__32loS","error":"Textarea_error__3CplP","readonly":"Textarea_readonly__Gd3pm","disabled":"Textarea_disabled__7xh4G"};